export default "__VITE_ASSET__B9UjzXlb__"